var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { HamiltonDatepicker as Datepicker } from '@amzn/atoz-web/Datepicker';
import { SpinnerOverlay } from '../SpinnerOverlay';
import { createDTDayInDefaultTZ, useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
import { getLocalJSDate } from './utilities';
export var DatePickerView = function (_a) {
    var selectedDate = _a.selectedDate, updateDateAction = _a.updateDateAction, daysWithAttention = _a.daysWithAttention, daysWithShifts = _a.daysWithShifts, daysWithPayDays = _a.daysWithPayDays, daysWithPunches = _a.daysWithPunches, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var _c = useSearchParams(), searchParams = _c[0], setSearchParams = _c[1];
    var t = useTranslation().t;
    var associateInfo = useAssociateContext().associateInfo;
    var features = useAssociateContext().features;
    var jsDatesWithShifts = daysWithShifts === null || daysWithShifts === void 0 ? void 0 : daysWithShifts.map(getLocalJSDate);
    var jsDatesWithPayDays = daysWithPayDays === null || daysWithPayDays === void 0 ? void 0 : daysWithPayDays.map(getLocalJSDate);
    var jsDatesWithPunches = daysWithPunches === null || daysWithPunches === void 0 ? void 0 : daysWithPunches.map(getLocalJSDate);
    var jsDatesWithAttention = daysWithAttention === null || daysWithAttention === void 0 ? void 0 : daysWithAttention.map(getLocalJSDate);
    // eslint-disable-next-line no-restricted-globals
    var onChangeAction = function (newDate) {
        var newDateTime = createDTDayInDefaultTZ(newDate);
        (newDateTime === null || newDateTime === void 0 ? void 0 : newDateTime.isValid) &&
            setSearchParams(__assign(__assign({}, Object.fromEntries(searchParams)), { date: newDateTime.toISODate() }), {
                replace: true
            });
        updateDateAction(newDateTime);
    };
    var markersAlignWithNativeFindShiftsUX = {
        primary: daysWithPunches && {
            label: t('shift_management_views_DatePicker_punch_legend'),
            dates: jsDatesWithPunches
        },
        triangle: daysWithShifts && {
            label: t('shift_management_views_DatePicker_shift_legend'),
            dates: jsDatesWithShifts
        },
        dot: daysWithPayDays && {
            label: t('shift_management_views_DatePicker_payday_legend'),
            dates: jsDatesWithPayDays
        },
        alert: daysWithAttention && {
            label: t('shift_management_views_DatePicker_attention_legend'),
            dates: jsDatesWithAttention
        }
    };
    var markersToBeDeprecated = {
        primary: daysWithPunches && {
            label: t('shift_management_views_DatePicker_punch_legend'),
            dates: jsDatesWithPunches
        },
        secondary: daysWithShifts && {
            label: t('shift_management_views_DatePicker_shift_legend'),
            dates: jsDatesWithShifts
        },
        tertiary: daysWithPayDays && {
            label: t('shift_management_views_DatePicker_payday_legend'),
            dates: jsDatesWithPayDays
        },
        attention: daysWithAttention && {
            label: t('shift_management_views_DatePicker_attention_legend'),
            dates: jsDatesWithAttention
        }
    };
    var markers = features.isNativeFindShiftsPageEnabled
        ? markersAlignWithNativeFindShiftsUX
        : markersToBeDeprecated;
    return (React.createElement(SpinnerOverlay, { isLoading: isLoading },
        React.createElement(Datepicker, { dataTestId: "DatePicker", selected: getLocalJSDate(selectedDate), inline: true, locale: associateInfo.locale, showDisabledMonthNavigation: true, formatWeekDay: function (day) {
                return day.substring(0, 3).toLocaleUpperCase();
            }, onChange: onChangeAction, onMonthChange: onChangeAction, headerTextProps: {
                fontSize: 'T400',
                role: 'heading',
                'aria-level': 2
            }, overrideTodayDate: getLocalJSDate(DateTime.now()), markers: markers, previousMonthAriaLabel: t('ess_shifts_dashboard_datePicker_prevButton'), nextMonthAriaLabel: t('ess_shifts_dashboard_datePicker_nextButton') })));
};
